import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getConsentMe, acceptConsentApi } from "../api";

/**
 * One-time click-wrap consent banner (Закон РК № 370 / № 94-V).
 * Shown to authenticated users who have not accepted the current
 * terms version. Acceptance is logged server-side.
 */
export const ConsentBanner = () => {
  const { t } = useTranslation();
  const [state, setState] = useState(null); // null=loading/hidden
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    getConsentMe()
      .then(d => { if (alive && !d.accepted) setState(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!state) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await acceptConsentApi("banner");
      setState(null);
    } catch (_e) { setBusy(false); }
  };

  return (
    <div className="position-fixed bottom-0 start-0 end-0 p-2 p-md-3" style={{ zIndex: 1080 }}
         data-testid="consent-banner">
      <div className="card shadow-lg border-0 mx-auto" style={{ maxWidth: 920, borderRadius: 14 }}>
        <div className="card-body d-flex flex-column flex-md-row align-items-md-center gap-2 gap-md-3 py-3">
          <i className="bi bi-shield-check fs-3 text-primary d-none d-md-block"></i>
          <div className="small flex-grow-1">
            {state.needs_reaccept ? t("legal.banner_updated") : t("legal.banner_text")}{" "}
            <Link to="/terms" target="_blank" data-testid="consent-banner-terms">{t("legal.terms_link")}</Link>
            {" "}{t("legal.and")}{" "}
            <Link to="/privacy" target="_blank" data-testid="consent-banner-privacy">{t("legal.privacy_link")}</Link>.
          </div>
          <button className="btn btn-primary btn-sm text-nowrap px-3" onClick={accept} disabled={busy}
                  data-testid="consent-banner-accept">
            {busy ? "…" : t("legal.accept_btn")}
          </button>
        </div>
      </div>
    </div>
  );
};
